export const CustomStyles = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  maxWidth: 500,
  backgroundColor: 'background.paper', // Changed from bgcolor to backgroundColor
  border: '2px solid #dc3545',
  boxShadow: '2px 2px 4px rgba(0, 0, 0, 0.1)', // Correct usage of boxShadow property
  padding: 2, // Changed from p to padding, assuming it's pixels
  borderRadius: 2 // Removed 'px' since it's a number
};